module.exports = __webpack_public_path__ + "img/yjyHeadBg.3d98395a.jpg";